import development from "./config.development.json";
import perf from "./config.perf.json";
import production from "./config.production.json";
import qa from "./config.qa.json";
import staging from "./config.staging.json";
import uat from "./config.uat.json";
import schema from "./schema.json";

export const configs = {
  development,
  perf,
  qa,
  staging,
  uat,
  production,
  schema,
};
